import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 570px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CardUploadContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  @media (max-width: 570px) {
    flex-direction: column;
  }
`;

export const Warning = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 8px;
  font-style: normal;
  font-weight: bold;
  line-height: 12px;
  letter-spacing: 0.08em;
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 40px;
  span {
    color: ${({ theme }) => theme.colors.error};
  }
`;

export const LabelWarning = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-align: left;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 12px;
`;
